"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBarWidget = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _queryString = _interopRequireDefault(require("query-string"));

var _core = require("@material-ui/core");

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _SearchSharp = _interopRequireDefault(require("@material-ui/icons/SearchSharp"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    searchWrapper: {
      height: 36,
      display: 'flex',
      backgroundColor: theme.palette.common.white,
      border: '1px solid',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: 4,
      width: '100%'
    },
    inputLeftButton: {
      minWidth: 24,
      margin: 8,
      marginLeft: 16
    },
    inputRightButton: {
      width: 24,
      minWidth: 24,
      margin: '0 8px'
    },
    resetButton: {
      padding: 0,
      textDecoration: 'none',
      backgroundColor: 'initial'
    },
    inputIcon: {
      color: 'black',
      verticalAlign: 'middle'
    },
    inputBaseRoot: {
      height: 24,
      padding: '6px 0'
    }
  };
});

var SearchBarWidget = function SearchBarWidget(props) {
  var searchCallback = props.searchCallback,
      searchPlaceHolder = props.searchPlaceHolder,
      inputWrapperClasses = props.inputWrapperClasses,
      hide = props.hide,
      hidden = props.hidden,
      onClickClose = props.onClickClose,
      breakpoint = props.breakpoint,
      closeBottomNavigation = props.closeBottomNavigation;
  var currentTheme = (0, _core.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(currentTheme.breakpoints.down(breakpoint));

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTyping = _useState2[0],
      setIsTyping = _useState2[1];

  var searchTerm = '';

  if (window.location.search && window.location.search.includes('?query=')) {
    searchTerm = _queryString.default.parse(window.location.search).query;
  }

  var _useState3 = (0, _react.useState)(searchTerm),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var classes = useStyles();

  var handleSubmit = function handleSubmit(evt) {
    evt.preventDefault();
    searchCallback(inputValue);
  };

  var clearSearch = function clearSearch() {
    setIsTyping(false);
    setInputValue('');

    if (onClickClose) {
      onClickClose();
    }
  };

  var handleSearchChange = function handleSearchChange(evt) {
    setInputValue(evt.target.value);

    if (evt.target.value === '') {
      setIsTyping(false);
      return;
    }

    if (!isTyping) {
      setIsTyping(true);
    }
  };

  if (hide) return null;
  var inputWrapperStyle = inputWrapperClasses ? "".concat(classes.searchWrapper, " ").concat(inputWrapperClasses) : classes.searchWrapper;

  var searchIcon = /*#__PURE__*/_react.default.createElement(_InputAdornment.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.inputLeftButton
  }, /*#__PURE__*/_react.default.createElement(_SearchSharp.default, {
    className: classes.inputIcon
  })));

  var arrowBackIcon = /*#__PURE__*/_react.default.createElement(_InputAdornment.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "".concat(classes.inputLeftButton, " ").concat(classes.resetButton),
    onClick: closeBottomNavigation
  }, /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
    className: classes.inputIcon
  })));

  var closeButton = /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
    position: "start"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: clearSearch,
    className: classes.inputRightButton
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)));

  return /*#__PURE__*/_react.default.createElement(_Hidden.default, hidden, /*#__PURE__*/_react.default.createElement("form", {
    className: inputWrapperStyle,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    disableUnderline: true,
    placeholder: searchPlaceHolder,
    fullWidth: true,
    onChange: handleSearchChange,
    value: inputValue,
    classes: {
      input: classes.inputBaseRoot
    },
    startAdornment: isMobile ? arrowBackIcon : searchIcon,
    endAdornment: isTyping || inputValue !== '' ? closeButton : null
  })));
};

exports.SearchBarWidget = SearchBarWidget;
SearchBarWidget.propTypes = {
  /** Função de busca a ser executada */
  searchCallback: _propTypes.default.func.isRequired,

  /** Texto do placeholder do input */
  searchPlaceHolder: _propTypes.default.string,

  /** Nome da classe para customizar o form do input */
  inputWrapperClasses: _propTypes.default.string,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** Token do breakpoint que define em qual resolução serão exibidas as fetures mobile (ex: o icone de retorno no input) */
  breakpoint: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),

  /** Função definida pela plataforma para fechar o widget (útil ao abrir o widget com um Bottom Navigation) */
  closeBottomNavigation: _propTypes.default.func,

  /** Função de callbcak para o icone de close do search  */
  onClickClose: _propTypes.default.func
};
SearchBarWidget.defaultProps = {
  searchPlaceHolder: 'Buscar...',
  inputWrapperClasses: null,
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  breakpoint: 'xs',
  closeBottomNavigation: null,
  onClickClose: null
};